import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ApiResult } from '../../models/ApiResult';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Location } from '@angular/common';
import { LocalizationService } from '../../services/localization.service';
import { ValidacionEditService } from '../../services/validacion-edit.service';
import { ActivatedRoute } from '@angular/router';
import { MatDialogModule, MatDialogRef, MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { INMTasacionesComponent } from '../inmtasaciones/inmtasaciones.component';
import { AuthService } from '../../services/auth.service';
import { TestigosEditComponent } from '../testigos-edit/testigos-edit.component';
import { DateHelper } from '../../models/NgDateCustomAdapter';

@Component({
  selector: 'app-validacion-edit',
  templateUrl: './validacion-edit.component.html',
  styleUrls: ['./validacion-edit.component.scss']
})
export class ValidacionEditComponent implements OnInit {

  valForm: FormGroup;
  valFormEdit: FormGroup;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  tasacionId: number;
  isModal: boolean;
  errorMessage: String = '';
  localization: LocalizationService;
  validacionEditMod: MatDialogConfig;
  hayValidacion: object;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private _valService: ValidacionEditService,
    public dialogRef: MatDialogRef<ValidacionEditComponent>, private _location: Location, localization: LocalizationService, public _authService: AuthService, private _dialog: MatDialog,
    public dateHelper: DateHelper, ) {
    this.validacionEditMod = new MatDialogConfig();
    this.validacionEditMod.disableClose = false;
    this.validacionEditMod.autoFocus = true;
    this.validacionEditMod.closeOnNavigation = true;
    this.validacionEditMod.disableClose = true;

    this.localization = localization;

    //if (this._avRoute.snapshot.params['id']) {
    //  this.id = this._avRoute.snapshot.params['id'];
    //} else {
    //  this.id = 0;
    //}

    this.valForm = this._fb.group({
      id: 0,
      tasacionId: [''],
      //nRegistral: [''],
      //nCatastral: [''],
      refCatastroOk: [false],
      dirCorrecta: [false],
      tipCorrecta: [false],
      alturaCorrecta: [false],
      supTesCorrecta: [false],
      valorUnitarioCorrecto: [false],
      valorPercetilesCorrecto: [false],
      homogenizacionCorrecta: [false],
      nTestigosCorrecto: [false],
      rSupConsUtil: [false],
      rSupUtilConst: [false],
      rSupAdoptada: [false],
      rSupAdopCatastral: [false],
      rSupAdopConst: [false],
      codPostal: [false],
      geoloc: [false],
      pMAdoptadosBanos: [false],
      pMAdoptadosHab: [false],
      valorEnZona: [false],
      final: [false]
    });

    this.valFormEdit = this._fb.group({
      refCatastroOk: [''],
      dirCorrecta: [''],
      tipCorrecta: [''],
      alturaCorrecta: [''],
    });
  }

  ngOnInit() {
    this._valService.hasValoracion(this.tasacionId.toString())
      .subscribe(resp => {
        this.hayValidacion = resp;
        if (resp) {
          this._valService.getValoracion(this.tasacionId.toString())
            .subscribe(resp => {
              console.log(resp);
              this.valForm.patchValue(resp);
            }, error => {
              this.errorMessage = error;
            });
        }
      }, error => {
        this.errorMessage = "Problemas al recuperar la validación";
      });

    
  }

  save() {
    this._valService.postValoracion(this.tasacionId.toString(), this.valFormEdit.controls['refCatastroOk'].value, this.valFormEdit.controls['dirCorrecta'].value, this.valFormEdit.controls['tipCorrecta'].value, this.valFormEdit.controls['alturaCorrecta'].value)
      .subscribe(resp => {
        console.log(resp);
        this.valForm.patchValue(resp);
        this._valService.hasValoracion(this.tasacionId.toString())
          .subscribe(resp => {
            this.hayValidacion = resp;
          }, error => {
            this.errorMessage = "Problemas al recuperar la validación";
          });
      }, error => {
        this.errorMessage = "Error al crear la valoración";
      });
  }

  recargar() {
    this._valService.delete(this.tasacionId.toString()).subscribe(
      resp => {
        if (resp) {
          this.ngOnInit();
        }
      }, error => {
        this.errorMessage = "No se ha podido borrar la valoración";
      });
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

}
